export default "dist/images/block-number-box-background.4606981.png";